import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const RackAddEditPageRBAC = {
  pageID: 'acd927bb755bb8c788be60b981fedbb3',
  elementID: {},
} as const

export const useRBACRackAddEditPage = createUseRBAC(RackAddEditPageRBAC.elementID)

export type UseRBACRackAddEditPageType = ReturnType<typeof useRBACRackAddEditPage>
